export default {
  data() {
    return {
      fullSize: this.getFullSize(),
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateSize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize)
  },

  computed: {
    availableWidth() {
      return parseInt(this.fullSize.width, 10)
    },

    availableHeight() {
      return parseInt(this.fullSize.height, 10)
    },
  },

  methods: {
    updateSize() {
      this.fullSize = this.getFullSize()
    },
    getFullSize() {
      return {
        width: `${window.innerWidth - 1}px`,
        height: `${window.innerHeight - 1}px`,
      }
    },
  },
}
